<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <router-link :to="{path:'/ExhibitionA4Detail/'+item.id}" tag="div" class="item" v-for="(item,index) in dataList" :key="index">
          <div class="pic">
            <img :src="item.picUrl" alt="">
            <div class="summary">{{item.name}}</div>
          </div>
          <div class="text text-hide" style="width: 440px;">{{item.title}}</div>
        </router-link>
        <div style="clear: both;"></div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[6, 12, 18, 24, 30]"
          :page-size="6"
          layout="total, sizes, prev, pager, next, jumper"
          :total="config.total">
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api"
  // import {getExhibitionA4} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";
  import {mixin} from '@/mixin/index'

  export default {
    name: "List",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data() {
      return {
        // 列表数据
        dataList: [],
        // 列表参数
        config: {
          name: '',
          total: 0,
          page: 1,
          limit: 6
        }
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 获取数据
        this.toGetData()
      }
    },
    created() {
      // 获取数据
      this.toGetData()
    },
    methods: {
      // 获取数据
      async toGetData() {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "内页冠军故事",
          articleKey:"cms",
        }
        let {data:{rows,total}} = await getSingle(params)

        // console.log(rows,total)

        rows.forEach( val => {
          this.dataList.push({
            id : val.id,
            title : val.smallTitle.split("|")[1],
            name : val.smallTitle.split("|")[0],
            picUrl : this.$store.getters.urlApi + val.faceUrl
          })
        })
        this.config.total = total
      },
      // toGetData() {
      //   getExhibitionA4(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6 !important;
  }

  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }

  .container {
    .wrap {
      width: 1440px;
      margin: 0 auto;
      overflow: hidden;
      padding-bottom: 140px;

      .item {
        width: 440px;
        height: 342px;
        margin: 0 30px 30px;
        background: #FFFFFF;
        box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
        float: left;
        cursor: pointer;

        .pic {
          width: 100%;
          height: 270px;
          position: relative;
          .summary {
            z-index: 8;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 175px;
            height: 46px;
            line-height: 46px;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            padding-right: 20px;
            background: url('https://www.cwmuseum.cn/img/Exhibition08@2x.png')
          }
          .summary.on{
            background: url('https://www.cwmuseum.cn/img/Exhibition08_active@2x.png')
          }
        }

        .text {
          padding: 24px 28px 0;
          font-family: PingFangSC;
          font-weight: 600;
          font-size: 24px;
          color: #333333;
        }
      }

      .item:nth-of-type(3n-1) {
        margin: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Exhibition/A4/List.vue